import { createActions, createReducer } from "reduxsauce";
import { call, put, all, takeEvery } from "redux-saga/effects";
import { axiosCall } from "../helpers/funtioncs";
import { Creators as creatorsProviders } from "../ducks/providers";
import { Creators as creatorsStores } from "../ducks/stores";
import { Creators as creatorsConfig } from "../ducks/config";
import Cookies from "js-cookie";
// const in1Hour = 1 / 14; //1 hora 43 minutos
const in1Hour = 1 / 24; //1 hora
//const in1Hour = 1 / 720; //2 minutos
//const in1Hour = 1 / 288; //5 minutos
const apiPetco_baseUrl = "https://app.petco.com.mx";
const apiPetcozoo_baseUrl = `${process.env.REACT_APP_API_PETCOZOO}`;
/* --------Sagas-----------*/
function* loginSaga({ dataUser }) {
  // //const { idNumber, password } = dataUser;

  try {
    const user = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/users/login`,
      data: dataUser,
      headers: {
        "Content-Type": "application/json",
      },
    });
    const { data } = user;
    const { token, roles } = data;
    Cookies.set("loginCookie", token, {
      expires: in1Hour,
    });
    const typeUser = data.user.typeUser;
    const sucursal = data.user.sucursal;
    const lastChangeTimestamp = Date.parse(data.user.lastChange);
    const currentTime = Date.now();
    const timeDifferenceInSeconds = (currentTime - lastChangeTimestamp) / 1000; // Calcula la diferencia en segundos

    const threeMonthsInSeconds = 7889400; // Aproximadamente 3 meses en segundos

    if (timeDifferenceInSeconds > threeMonthsInSeconds) {
      //console.log("Mostrar mensaje de cambio de contraseña");
      yield put({
        type: "REDIRECT_TO_PASSWORD_SCREEN",
      });
    } else {
      //console.log("La diferencia es menor a 3 meses");
    }

    if (typeUser === "ADMIN") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
        yield put(Creators.getAllUsers(token)),
      ]);
    } else if (typeUser === "PROVIDER") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(creatorsProviders.getProviderById(token, data.user.idNumber)),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    } else if (typeUser === "STORE") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(creatorsStores.getStoreById(token, data.user.idNumber)),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    } else if (typeUser === "VENTA") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),

        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    } else if (typeUser === "SUPERVISOR") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),

        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
        yield put(Creators.getAllUsers(token)),
      ]);
    } else if (typeUser === "GPI") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(Creators.getAllUsers(token)),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    }
  } catch (error) {
    //console.log(error);
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(Creators.fail()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}

function* getAllUsersSaga({ token }) {
  try {
    const AllUsers = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/users/getAllUsers`,
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    });
    yield put(Creators.getUsersSuccess(AllUsers.data));
  } catch (error) {
    console.error("Error fetching Stores:", error);
    yield put(Creators.fail());
  }
}
function* changePasswordSaga({ token, dataUser }) {
  if (!dataUser) {
    return;
  }

  try {
    //console.log("Token:", token);
    const response = yield call(axiosCall, {
      method: "post",
      url: `${apiPetcozoo_baseUrl}/users/update-password`,

      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      data: dataUser,
    });
    //console.log(response);
    const { idNumber, newPassword } = dataUser;

    yield all([
      yield put(Creators.changePasswordSuccess()),
      yield put(
        creatorsConfig.message({
          text: `Se actualizo tu password correctamente`,
          type: "success",
        })
      ),
      yield put(Creators.logout()),
      yield put(Creators.login({ idNumber, password: newPassword })),
    ]);
  } catch (error) {
    //console.log(error);
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* loginCookiesSagas({ cookie }) {
  Cookies.set("sesion", Date.now());
  try {
    const user = yield call(axiosCall, {
      method: "get",
      url: `${apiPetcozoo_baseUrl}/users/loginCookie`,
      headers: {
        "Content-Type": "application/json",
        authorization: cookie,
      },
    });

    const { data } = user;
    const { token, roles } = data;

    Cookies.set("loginCookie", token, {
      expires: in1Hour,
    });
    const typeUser = data.user.typeUser;
    if (typeUser === "ADMIN") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
        yield put(Creators.getAllUsers(token)),
      ]);
    } else if (typeUser === "PROVIDER") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(creatorsProviders.getProviderById(token, data.user.idNumber)),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    } else if (typeUser === "STORE") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),
        yield put(creatorsStores.getStoreById(token, data.user.idNumber)),
        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    } else if (typeUser === "VENTA") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),

        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    } else if (typeUser === "SUPERVISOR") {
      yield all([
        yield put(
          Creators.loginSuccess(data.user.idNumber, token, data.user, roles)
        ),

        yield put(
          creatorsConfig.message({ text: `Datos correctos`, type: "success" })
        ),
      ]);
    }
  } catch (error) {
    const message =
      error.response !== null
        ? error.response.data.message
        : "Ocurrio un error";
    yield all([
      yield put(Creators.fail()),
      yield put(creatorsConfig.message({ text: message, type: "error" })),
    ]);
  }
}
function* logoutSaga() {
  try {
    Cookies.remove("loginCookie");
    yield all([
      yield put(Creators.logoutSuccess()),
      yield put(creatorsProviders.clearAllProviders()),
      yield put(creatorsStores.clearAllStores()),
      yield put(creatorsConfig.clearMessage()),
    ]);
  } catch (error) {
    yield put(Creators.fail());
  }
}
function* getInfoByPostalCodeSaga({ codigoPostal }) {
  try {
    const response = yield call(axiosCall, {
      method: "get",
      url: `${apiPetco_baseUrl}/petcoach/colonias/${codigoPostal}`,
      headers: {
        "x-api-pe-wss":
          "681ae67106810684b039e48aa9aa2c6d440ef1867e71f96bb98515a104c77c5b",
      },
    });

    if (response.status === 400) {
      //console.log("Bad Request: Código postal inválido");
      yield put(Creators.getInfoByPostalCodeFail()); // Manejar el error de código postal inválido
    } else {
      yield put(Creators.getInfoByPostalCodeSuccess(response.data));
    }
  } catch (error) {
    console.error("Error fetching data by postal code:", error);
    yield put(Creators.getInfoByPostalCodeFail());
  }
}
export default function* users() {
  yield all([
    takeEvery(Types.LOGIN, loginSaga),
    takeEvery(Types.GET_ALL_USERS, getAllUsersSaga),
    takeEvery(Types.LOGOUT, logoutSaga),
    takeEvery(Types.LOGIN_COOKIES, loginCookiesSagas),
    takeEvery(Types.CHANGE_PASSWORD, changePasswordSaga),
    takeEvery(Types.GET_INFO_BY_POSTAL_CODE, getInfoByPostalCodeSaga),
  ]);
}
/*-----------Action types & creators-------------*/
export const { Types, Creators } = createActions({
  login: ["dataUser"],
  getAllUsers: ["token"],
  getUsersSuccess: ["users"],
  loginSuccess: ["idNumber", "uid", "data", "menu"],
  loginCookies: ["cookie"],
  clearMessage: null,
  logout: null,
  logoutSuccess: null,
  changePassword: ["token", "dataUser"],
  changePasswordSuccess: null,
  changePasswordFail: null,
  redirectToPasswordScreen: null,
  fail: null,
  getInfoByPostalCode: ["codigoPostal"],
  getInfoByPostalCodeSuccess: ["data"],
  getInfoByPostalCodeFail: null,
  folioInfo: ["folioInfo"],
  setTiendaAsociada: ["tiendaAsociada"],
});
/*------------Reducers-----------*/
const INITIAL_STATE = {
  loading: false,
  logged: false,
  uid: null,
  data: {},
  menu: [],
  error: null,
  infoByPostalCode: null,
};
const login = (state = INITIAL_STATE) => ({
  ...state,
  logged: false,
  loading: true,
  error: null,
});
const loginCookies = (state = INITIAL_STATE) => ({
  ...state,
  logged: false,
  loading: true,
});
const loginSuccess = (
  state = INITIAL_STATE,
  { idNumber, uid, data, menu }
) => ({
  ...state,
  logged: true,
  loading: false,
  uid: uid,
  data: data,
  menu: menu,
  idNumber: idNumber,
});
const getAllUsers = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});
const getUsersSuccess = (state = INITIAL_STATE, { users }) => {
  return {
    ...state,
    loading: false,
    users: users,
  };
};
const redirectToPasswordScreen = (state = INITIAL_STATE) => ({
  ...state,
  redirectToPasswordScreen: true,
});
const changePasswordSuccess = (state = INITIAL_STATE) => ({
  ...state,
  logged: true,
  loading: false,
});
const changePassword = (state = INITIAL_STATE) => ({
  ...state,
  logged: true,
  loading: false,
  redirectToPasswordScreen: false,
});
const changePasswordFail = (state = INITIAL_STATE) => ({
  ...state,
  logged: true,
  loading: false,
});
const logout = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  logged: false,
  uid: null,
  data: {},
  menu: [],
});
const logoutSuccess = (state = INITIAL_STATE) => ({
  ...state,
  logged: false,
  loading: false,
  uid: null,
  data: {},
  rolData: {},
});
const fail = (state = INITIAL_STATE) => ({
  ...state,
  logged: false,
  loading: false,
  error: "Error al ingresar los datos",
});
const getInfoByPostalCode = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
});

const getInfoByPostalCodeSuccess = (state = INITIAL_STATE, { data }) => ({
  ...state,
  loading: false,
  infoByPostalCode: data,
});

const getInfoByPostalCodeFail = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  error: "Error al obtener la información por código postal",
  infoByPostalCode: "Error al obtener la información por código postal",
});

const HANDLERS = {
  [Types.LOGIN]: login,
  [Types.LOGIN_SUCCESS]: loginSuccess,
  [Types.LOGIN_COOKIES]: loginCookies,
  [Types.LOGOUT]: logout,
  [Types.LOGOUT_SUCCESS]: logoutSuccess,
  [Types.GET_ALL_USERS]: getAllUsers,
  [Types.GET_USERS_SUCCESS]: getUsersSuccess,
  [Types.CHANGE_PASSWORD]: changePassword,
  [Types.CHANGE_PASSWORD_SUCCESS]: changePasswordSuccess,
  [Types.CHANGE_PASSWORD_FAIL]: changePasswordFail,
  [Types.REDIRECT_TO_PASSWORD_SCREEN]: redirectToPasswordScreen,
  [Types.FAIL]: fail,
  [Types.GET_INFO_BY_POSTAL_CODE]: getInfoByPostalCode,
  [Types.GET_INFO_BY_POSTAL_CODE_SUCCESS]: getInfoByPostalCodeSuccess,
  [Types.GET_INFO_BY_POSTAL_CODE_FAIL]: getInfoByPostalCodeFail,
};
export const reducersUsers = createReducer(INITIAL_STATE, HANDLERS);
